<template>
  <v-combobox
    v-bind="$attrs"
    :items="countriesList"
    v-model="country"
    item-text="name"
    return-object
    @change="change"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CountrySelect',

  props: {
    value: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      country: ''
    }
  },

  computed: {
    ...mapGetters(['countries', 'allowedCountries']),

    countriesList () {
      if (!this.allowedCountries.length) {
        return this.countries
      }

      return this.countries.filter(country => this.allowedCountries.includes(country.code))
    }
  },

  watch: {
    value: function () {
      this.setCountry()
    }
  },

  async mounted () {
    if (this.countries.length === 0) {
      await this.initCountries()
    }

    if (this.allowedCountries.length === 0) {
      await this.initAllowedLists()
    }

    this.setCountry()
  },

  methods: {
    ...mapActions(['setCountries', 'setAllowedLists']),

    change () {
      if (!this.country) {
        return
      }

      this.$emit('input', this.country.code)
    },

    setCountry () {
      this.country = this.countriesList.find(item => item.code === this.value)
    },

    async initCountries () {
      const countries = await this.$http.make('country').get()
      this.setCountries(countries)
    },

    async initAllowedLists () {
      const settings = await this.$http.make('settings').find('localisation/countries')
      this.setAllowedLists(settings)
    }
  }
}
</script>
